// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2e44def6ad492c60a573","655":"8d1eb5cb4da347b78446"}[chunkId] + ".js";
};